/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const Button = require('@andes/button');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const { Link } = require('frontend-spa');
const HomeBanner = require('./components/HomeBanner');

const ContactDev = require('../../ContactDeveloper');
const MenuUtils = require('../../../../utils/menu');
const { sanitizePath } = require('../../../common/URLSanitizer');
const HomeImages = require('./images');
const { getEventTracker } = require('../../../../utils/event-tracker');

function Home(props) {
  const Tracker = getEventTracker();
  const { i18n, platform, lang, setActiveItem, email, isContactSuscribed, userData } = props;

  const {
    HomeTitleImage,
    HomeCardOnlinePayment,
    HomeCardInperson,
    HomeCardPlugins,
    HomeFooterSupport,
    HomeFooterGitHub,
    HomeFooterStatusPage,
    HomeNonDeveloperBanner,
    HomeDevProgramBanner,
  } = HomeImages;

  return (
    <div className="home-container">

      <HomeBanner
        i18n={i18n}
        siteId={platform.siteId}
      />

      <div className="home-title">
        <div className="home-title__text">
          <h1>{i18n.gettext('Implementa la solución de pagos ideal para cualquier tipo de negocio')}</h1>
        </div>
        <div className="home-title__image">
          <HomeTitleImage />
        </div>
      </div>

      <div className="home-fast-access">
        <Card className="home-fast-access__card" animated>
          <Link
            to={`/developers/${lang}/guides/online-payments`}
            onClick={() => {
              Tracker.send('mpdevelopers/click_home_op_landing');
              setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/online-payments`), platform.siteId.toLowerCase(), lang));
            }}
          >
            <CardContent className="card-content">
              <HomeCardOnlinePayment />
              <h3>{i18n.gettext('Cobros online')}</h3>
              <p>{i18n.gettext('Usa la API de pagos o nuestros checkouts para cobrar desde redes sociales, sitios web y aplicaciones')}.</p>
            </CardContent>
          </Link>
        </Card>

        <Card className="home-fast-access__card" animated>
          <Link
            to={`/developers/${lang}/guides/in-person-payments`}
            onClick={() => {
              Tracker.send('mpdevelopers/click_home_ipp_landing');
              setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/in-person-payments`), platform.siteId.toLowerCase(), lang));
            }}
          >
            <CardContent className="card-content">
              <HomeCardInperson />
              <h3>{i18n.gettext('Pagos presenciales')}</h3>
              <p>{i18n.gettext('Ofrece pagos en puntos de venta, con todas las tarjetas y dispositivos móviles')}.</p>
            </CardContent>
          </Link>
        </Card>

        <Card className="home-fast-access__card" animated>
          <Link
            to={`/developers/${lang}/guides/plugins`}
            onClick={() => {
              Tracker.send('mpdevelopers/click_home_plugins_landing');
              setActiveItem(MenuUtils.getItemFromURLParent(sanitizePath(`/developers/${lang}/guides/plugins`), platform.siteId.toLowerCase(), lang));
            }}
          >
            <CardContent className="card-content">
              <HomeCardPlugins />
              <h3>{i18n.gettext('Plugins y plataformas')}</h3>
              <p>{i18n.gettext('Acepta pagos en Shopify, WooCommerce, Prestashop y otras plataformas de e-commerce')}.</p>
            </CardContent>
          </Link>
        </Card>
      </div>

      <div className="home-banner">
        <div className="home-banner__content">
          <Card paddingSize={0} className="home-banner-card">
            <CardContent className="home-banner-card__content">
              <div className="home-banner-card__image">
                <HomeNonDeveloperBanner />
              </div>
              <div className="home-banner-card__text-container">
                <h3 className="home-banner-card__title">
                  {i18n.gettext('¿No eres desarrollador?')}
                </h3>
                <p className="home-banner-card__subtitle">
                  {i18n.gettext('Implementa nuestras soluciones de pago sin usar código.')}
                </p>
                <Button
                  size="small"
                  onClick={() => { Tracker.send('mpdevelopers/click_home_banner_non-developer'); }}
                  href={`/developers/${lang}/guides/overview`}
                  className="home-banner-card__button"
                >
                  {i18n.gettext('Conocer más')}
                </Button>
              </div>
            </CardContent>
          </Card>
          <Card paddingSize={0} className="home-banner-card">
            <CardContent className="home-banner-card__content">
              <div className="home-banner-card__image">
                <HomeDevProgramBanner />
              </div>
              <div className="home-banner-card__text-container">
                <h3 className="home-banner-card__title">
                  {i18n.gettext('<DEV>PROGRAM')}
                </h3>
                <p className="home-banner-card__subtitle">
                  {i18n.gettext('Súmate al programa para desarrolladores y obtén beneficios extras.')}
                </p>
                <Button
                  size="small"
                  href={`/developers/${lang}/developer-program`}
                  className="home-banner-card__button"
                  onClick={() => { Tracker.send('mpdevelopers/click_home_banner_devprogram'); }}
                >
                  {i18n.gettext('Conocer más')}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className="home-footer">
        <div className="home-footer__card--first">
          <HomeFooterSupport />
          <h4>{i18n.gettext('¿Tienes dudas técnicas con tu integración?')}</h4>
          <a onClick={() => { Tracker.send('mpdevelopers/click_home_support_cta'); }} href={`/developers/${lang}/support`}>{i18n.gettext('Consulta con nuestro soporte')}</a>
        </div>

        <div className="home-footer__card--middle">
          <HomeFooterGitHub />
          <h4>{i18n.gettext('¿Sugerencias para mejorar la documentación?')}</h4>
          <a onClick={() => { Tracker.send('mpdevelopers/click_home_github_cta'); }} href="https://github.com/mercadopago/devsite-docs" target="_blank">{i18n.gettext('Envíanos tu Pull Request')}</a>
        </div>

        <div className="home-footer__card--last">
          <HomeFooterStatusPage />
          <h4>{i18n.gettext('Conoce el estado de nuestros servicios')}</h4>
          <a onClick={() => { Tracker.send('mpdevelopers/click_home_statuspage_cta'); }} href="https://status.mercadopago.com/" target="_blank">{i18n.gettext('Ir a Statuspage')}</a>
        </div>
      </div>
      <div>
        <ContactDev
          i18n={i18n}
          userData={userData}
          email={email}
          lang={lang}
          platform={platform}
          isContactSuscribed={isContactSuscribed}
        />
      </div>
    </div>
  );
}

Home.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
  platform: PropTypes.shape({
    siteId: PropTypes.string,
    domain: PropTypes.string,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  setActiveItem: PropTypes.func.isRequired,
};

Home.defaultProps = {
  i18n: { gettext: () => { } },
};

module.exports = Home;
